export default {
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios.',
    successfully_saved: 'Guardado correctamente.',
  },
  form: {
    has_multiple_locations: {
      label: 'Establecer distintas ubicaciones para la semana',
    },
  },
  labels: {
    day_location: 'Ubicación {{day}} {{index}}',
    selected_days: 'Días seleccionados',
    orders_paused: 'Pedidos pausados',
    open_time: 'Hora de apertura',
    close_time: 'Hora de cierre',
  },
  buttons: {
    save: 'Guardar',
  },
};
